export default __webpack_public_path__ + "static/media/pasajes.5b0000ec.jpg";